<template>
  <div class="buttons">
    <a class="button pagination" @click="prev_page()" :disabled="!has_prev_page"><span class="icon"><i class="fa fa-chevron-left"></i></span></a>
    <a class="button pagination" @click="next_page()" :disabled="!has_next_page || !dest_obj[dest_name].next_page"><span class="icon"><i class="fa fa-chevron-right"></i></span></a>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Pagination',
  props: ['dest_obj', 'dest_name', 'endpoint'],
  data () {
    return {
      page: 1
    }
  },
  computed: {
    has_prev_page () {
      return this.dest_obj[this.dest_name] && this.dest_obj[this.dest_name].prev_page
    },
    has_next_page () {
      return this.dest_obj[this.dest_name] && this.dest_obj[this.dest_name].next_page
    }
  },
  methods: {
    fetch () {
      axios.get(this.endpoint + '?page=' + this.page)
        .then(response => {
          this.dest_obj[this.dest_name] = response.data.items
        })
    },
    prev_page () {
      if (this.dest_obj[this.dest_name].prev_page) {
        this.page--
        if (this.page < 1) {
          this.page = 1
        }
        this.fetch()
      }
    },

    next_page () {
      if (this.dest_obj[this.dest_name].next_page) {
        this.page++
        this.fetch()
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
